import { UpdatePublicLoadParams, UpdatePublicLoadParamsV3 } from './Guest.model';

import api, { apiMultipart, twUrl } from '../../utils/api';
import { LoadDocument, LoadDocumentParams, StopSignature } from '../../redux/api/load/load.model';
import { BaseQueryParams } from '../Global.model';
import { DispatchNoteResponse } from '../../components/TwDispatchNotes/TwDispatchNotes';
import { SharedTokenResponse } from '../../redux/api/orders/orders.model';

class GuestService {
  /**
   * Gets load data
   */
  static getPublicLoad(token: string): Promise<SharedTokenResponse> {
    return new Promise((resolve, reject) => {
      const apiResponse = api.get(twUrl.publicLoad(token));

      apiResponse
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  }

  /**
   * Gets load file
   */
  static getLoadFile(token: string, id: string): Promise<Blob> {
    return new Promise((resolve, reject) => {
      const apiResponse = api.get(`orders/t/${token}/attachments/${id}/files-vysor`, {
        responseType: 'blob'
      });

      apiResponse
        .then((response) => resolve(response.data))
        .catch((error) => {
          reject(error);
        });
    });
  }

  /**
   * Update public load
   */
  static updatePublicLoad(token: string, loadData: UpdatePublicLoadParams): Promise<number> {
    return new Promise((resolve, reject) => {
      const apiResponse = api.put(twUrl.publicLoad(token), loadData);

      apiResponse
        .then((response) => {
          resolve(response.status);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  }

  /**
   * Update public load v3
   */
  static updatePublicLoadV3(token: string, loadData: UpdatePublicLoadParamsV3): Promise<number> {
    return new Promise((resolve, reject) => {
      const apiResponse = api.put(twUrl.v3.publicLoad(token), loadData);

      apiResponse
        .then((response) => {
          resolve(response.status);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  }

  /**
   * Saves signature for a stop in public load
   * @param signatureFile
   * @param stopId
   * @param token
   */
  /*  static saveSignature(
    signatureFile: Blob,
    stopId: string,
    token: string,
    fullName: string
  ): Promise<number> {
    return new Promise((resolve, reject) => {
      const formData = new FormData();

      formData.append('signature', signatureFile);
      formData.append('full_name', fullName);

      const apiResponse = apiMultipart.post(
        twUrl.v3.saveSignature(stopId, undefined, token),
        formData
      );

      apiResponse
        .then((response) => {
          resolve(response.status);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  } */

  /**
   * Gets signature for a stop in public load
   * @param stopId
   * @param token
   */
  /*   static getSignature(stopId: string, token: string): Promise<StopSignature> {
    return new Promise((resolve, reject) => {
      const apiResponse = api.get(twUrl.v3.getSignature(stopId, undefined, token));

      apiResponse
        .then((response) => resolve(response.data.data))
        .catch((error) => {
          reject(error);
        });
    });
  } */

  static getDispatchNotes(
    loadId: string,
    params: BaseQueryParams,
    token: string
  ): Promise<{ data: DispatchNoteResponse[]; total: number }> {
    return new Promise((resolve, reject) => {
      const apiResponse = api.get(twUrl.v3.getDispatchNotes(loadId, token), { params });

      apiResponse
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  }

  static postDispatchNote(loadId: string, body: any, token: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const apiResponse = api.post(twUrl.v3.postDispatchNote(loadId, token), { ...body });

      apiResponse
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  }

  static deleteDispatchNote(loadId: string, noteId: string, token: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const apiResponse = api.delete(twUrl.v3.deleteDispatchNote(loadId, noteId, token));

      apiResponse
        .then((response) => {
          resolve(response.status);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  }
}

export default GuestService;
